import React, { useState, useRef, useEffect } from "react";

export default function SidebarTabs({ tabs, activeId: controlledId, onTabChange }) {
  const [internalId, setInternalId] = useState(tabs[0]?.id);
  const isControlled = controlledId !== undefined;
  const activeId = isControlled ? controlledId : internalId;
  const contentRef = useRef(null);
  const tabBarRef = useRef(null);

  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.scrollTop = 0;
    }
    if (tabBarRef.current) {
      const activeBtn = tabBarRef.current.querySelector('[aria-selected="true"]');
      if (activeBtn) {
        activeBtn.scrollIntoView?.({ behavior: "smooth", block: "nearest", inline: "nearest" });
      }
    }
  }, [activeId]);

  const handleClick = (id) => {
    if (isControlled) {
      onTabChange?.(id);
    } else {
      setInternalId(id);
    }
  };

  const activeTab = tabs.find((t) => t.id === activeId);

  return (
    <div className="sidebar-tabs">
      <div className="sidebar-tabs-bar" ref={tabBarRef} role="tablist">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            role="tab"
            aria-selected={tab.id === activeId}
            className={`sidebar-tab ${tab.id === activeId ? "sidebar-tab--active" : ""}`}
            onClick={() => handleClick(tab.id)}
            type="button"
          >
            {tab.label}
            {tab.badge > 0 && (
              <span className="sidebar-tab-badge">{tab.badge}</span>
            )}
          </button>
        ))}
      </div>
      <div className="sidebar-tabs-content" ref={contentRef} role="tabpanel">
        {activeTab?.content}
      </div>
    </div>
  );
}
